import React from 'react';
import { clsb, clsx } from 'js/utils/classNames.util';
import { Tooltip } from 'js/components/common/Tooltip';

import * as Types from './types';

import '../../FormFields.scss';
import style from './Label.scss';

export const Label: React.FC<Types.ILabelProps> = ({
    id,
    label,
    classNames,
    className,
    infoTooltip,
    isLabelAsteriskEnabled,
    ...props
}) => (
    <label htmlFor={id} className={clsx([clsb([style, classNames], ['label']), className])} {...props}>
        {label}
        {isLabelAsteriskEnabled && <span className={style.fieldLabelAsterisk}>*</span>}
        {label && infoTooltip && <Tooltip content={infoTooltip} className={style.tooltipIcon} />}
    </label>
);
